import { Directive, OnInit, Output, ElementRef, Renderer2, EventEmitter, Input } from '@angular/core';
import jQuery from 'jquery';
import { IDragData, vbDraggableKey } from './Draggable.AngularDirective';

@Directive({
	selector: '[vbDroppable]',
	host: {
		class: 'vb-droppable'
	},
	standalone: false
})
export class DroppableDirective implements OnInit {
	@Input() public accept: (draggableData: any) => boolean;
	@Input() public dropEnabled: boolean = true;
	@Output() public drop = new EventEmitter<any>();

	private static readonly HOVER_CSS_CLASS: string = 'vb-draggable-hover';

	constructor(
		private readonly $element: ElementRef,
		private readonly renderer: Renderer2
	) {
	}

	public ngOnInit(): void {
		if (!this.dropEnabled) {
			return;
		}

		const $el = jQuery(this.$element.nativeElement);

		($el as any).droppable({
			hoverClass: 'vb-droppable-hover',
			tolerance: 'pointer',

			accept: this.accept ? (el: JQuery) => {
				const draggable = el.data(vbDraggableKey) as IDragData;
				return draggable
					? this.accept(draggable.data)
					: false;
			} : undefined,

			over: (e: Event, ui: JQueryUI.DroppableEventUIParam) => {
				this.renderer.addClass(ui.draggable[0], DroppableDirective.HOVER_CSS_CLASS);

				if (ui.helper?.[0]) {
					this.renderer.addClass(ui.helper[0], DroppableDirective.HOVER_CSS_CLASS);
				}
			},
			out: (e: Event, ui: JQueryUI.DroppableEventUIParam) => {
				this.renderer.removeClass(ui.draggable[0], DroppableDirective.HOVER_CSS_CLASS);

				if (ui.helper?.[0]) {
					this.renderer.removeClass(ui.helper[0], DroppableDirective.HOVER_CSS_CLASS);
				}
			},
			drop: (e: Event, ui: JQueryUI.DroppableEventUIParam): void => {
				const draggable = ui.draggable.data(vbDraggableKey) as IDragData;
				if (draggable) {
					draggable.onDrop(this);
					this.drop.emit(draggable.data);
				}
			}
		});
	}

}
